import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=b607b7d4&scoped=true"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=b607b7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b607b7d4",
  null
  
)

export default component.exports